import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home';
import River from './views/River';
import RiverDetail from './views/River/Detail';
import Guide from './views/Guide';
import Instruction from './views/Instruction';
import InstructionDetail from './views/Instruction/Detail';
import Attractions from './views/Attractions';
import AttractionsDetail from './views/Attractions/Detail';
import Customize from './views/Customize';
import Food from './views/Food';
import Tour from './views/Tour';
import Couple from './views/Couple';
import Family from './views/Family';
import Culture from './views/Culture';
import Everything from './views/Everything';
import News from './views/News';
import Event from './views/Event';
import EventDetail from './views/Event/Detail';
import Game from './views/Game';
import ARMenu from './views/ARMenu';
import Campaign from './views/Campaign';
import Certificate from './views/Certificate';
import QRCodeUrlList from './views/QRCodeUrlList';
import Carbon from './views/Carbon';
import Helper from './views/Carbon/Helper';
import Calculator from './views/Carbon/Calculator';
import CalculatorFood from './views/Carbon/calculator/Food';
import CalculatorCloth from './views/Carbon/calculator/Cloth';
import CalculatorLiving from './views/Carbon/calculator/Living';
import CertificationMark from './views/Carbon/CertificationMark';
import CertificationMarkNext from './views/Carbon/CertificationMarkNext';
import StepsCalculator from './views/Carbon/calculator/StepsCalculator';

import Steps from './views/Carbon/calculator/Steps';
import Puzzle from './views/Carbon/Puzzle';
import Reward from './views/Reward';

Vue.use(Router);
const router = new Router({
    //   mode: "history",
    routes: [
        // 首頁
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                    },
                ],
                keepAlive: true,
            },
        },
        // 走讀河川
        {
            path: '/guide',
            name: 'Guide',
            component: Guide,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '走讀河川',
                    },
                ],
            },
        },
        // 走讀河川-列表導覽解說牌
        {
            path: '/guide/instruction',
            name: 'Instruction',
            component: Instruction,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '走讀河川',
                        link: '/guide',
                    },
                    {
                        name: '列表導覽-解說牌',
                        link: '/guide/instruction',
                    },
                ],
            },
        },
        // 走讀河川-列表導覽解說牌詳細頁面
        {
            path: '/guide/instruction/:id',
            name: 'InstructionDetail',
            component: InstructionDetail,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '走讀河川',
                        link: '/guide',
                    },
                    {
                        name: '列表導覽-解說牌',
                        link: '/guide/instruction',
                    },
                    {
                        name: '詳細頁面',
                        link: '/guide/instruction/:id',
                    },
                ],
            },
        },
        // 走讀河川-列表導覽景點
        {
            path: '/guide/attractions',
            name: 'Attractions',
            component: Attractions,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '走讀河川',
                        link: '/guide',
                    },
                    {
                        name: '列表導覽',
                        link: '/guide/attractions',
                    },
                ],
            },
        },
        // 走讀河川-列表導覽景點詳細頁面
        {
            path: '/guide/attractions/:id',
            name: 'AttractionsDetail',
            component: AttractionsDetail,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '走讀河川',
                        link: '/guide',
                    },
                    {
                        name: '列表導覽',
                        link: '/guide/attractions',
                    },
                    {
                        name: '詳細頁面',
                        link: '/guide/attractions/:id',
                    },
                ],
            },
        },
        // 走讀河川-列表導覽美食
        {
            path: '/guide/food',
            name: 'Food',
            component: Food,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '走讀河川',
                        link: '/guide',
                    },
                    {
                        name: '列表導覽-美食',
                        link: '/guide/food',
                    },
                ],
            },
        },
        // 走讀河川-自訂導覽
        {
            path: '/guide/customize',
            name: 'Customize',
            component: Customize,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '走讀河川',
                        link: '/guide',
                    },
                    {
                        name: '自訂導覽',
                        link: '/guide/customize',
                    },
                ],
            },
        },
        // 走讀河川-分眾導覽選單
        {
            path: '/guide/tour',
            name: 'Tour',
            component: Tour,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '走讀河川',
                        link: '/guide',
                    },
                    {
                        name: '分眾導覽',
                        link: '/guide/tour',
                    },
                ],
            },
        },
        // 走讀河川-分眾導覽情侶
        {
            path: '/guide/tour/couple',
            name: 'Couple',
            component: Couple,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '走讀河川',
                        link: '/guide',
                    },
                    {
                        name: '分眾導覽',
                        link: '/guide/tour',
                    },
                    {
                        name: '分眾導覽-情侶',
                        link: '/guide/tour/couple',
                    },
                ],
            },
        },
        // 走讀河川-分眾導覽親子
        {
            path: '/guide/tour/family',
            name: 'Family',
            component: Family,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '走讀河川',
                        link: '/guide',
                    },
                    {
                        name: '分眾導覽',
                        link: '/guide/tour',
                    },
                    {
                        name: '分眾導覽-親子',
                        link: '/guide/tour/family',
                    },
                ],
            },
        },
        // 走讀河川-分眾導覽人文
        {
            path: '/guide/tour/culture',
            name: 'Culture',
            component: Culture,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '走讀河川',
                        link: '/guide',
                    },
                    {
                        name: '分眾導覽',
                        link: '/guide/tour',
                    },
                    {
                        name: '分眾導覽-人文',
                        link: '/guide/tour/culture',
                    },
                ],
            },
        },
        // 川流城事
        {
            path: '/river',
            name: 'River',
            component: River,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '川流城事',
                        link: '/river',
                    },
                ],
            },
        },
        // 川流城事詳細頁面
        {
            path: '/river/:id',
            name: 'RiverDetail',
            component: RiverDetail,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '川流城事',
                        link: '/river',
                    },
                    {
                        name: '',
                        link: '/river/:id',
                    },
                ],
            },
        },
        // 川流城事詳細頁面-更多周邊景點
        {
            path: '/river/:id/around',
            name: 'AroundAttractions',
            component: Attractions,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '川流城事',
                        link: '/river',
                    },
                    {
                        name: '',
                        link: '/river/:id',
                    },
                    {
                        name: '更多周邊景點',
                        link: '/river/:id/around',
                    },
                ],
            },
        },
        // 川柳大小事
        {
            path: '/everything',
            name: 'Everything',
            component: Everything,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '川柳大小事',
                        link: '/everything',
                    },
                ],
            },
        },
        // 最新消息
        {
            path: '/everything/news',
            name: 'News',
            component: News,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '川柳大小事',
                        link: '/everything',
                    },
                    {
                        name: '最新消息',
                        link: '/everything/news',
                    },
                ],
            },
        },
        // 活動行事曆
        {
            path: '/everything/event',
            name: 'Event',
            component: Event,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '川柳大小事',
                        link: '/everything',
                    },
                    {
                        name: '活動行事曆',
                        link: '/everything/event',
                    },
                ],
            },
        },
        // 活動行事曆詳細頁面
        {
            path: '/everything/event/:id',
            name: 'EventDetail',
            component: EventDetail,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '川柳大小事',
                        link: '/everything',
                    },
                    {
                        name: '活動行事曆',
                        link: '/everything/event',
                    },
                    {
                        name: '詳細頁面',
                        link: '/everything/event/:id',
                    },
                ],
            },
        },
        // 互動遊戲選單
        {
            path: '/game',
            name: 'Game',
            component: Game,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '互動遊戲',
                        link: '/game',
                    },
                ],
            },
        },
        // 川閱古今選單
        {
            path: '/game/arMenu',
            name: 'ARMenu',
            component: ARMenu,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '互動遊戲',
                        link: '/game',
                    },
                    {
                        name: '川閱古今',
                        link: '/game/arMenu',
                    },
                ],
            },
        },
        // 宣傳活動
        {
            path: '/campaign',
            name: 'Campaign',
            component: Campaign,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '川柳不息來集章',
                        link: '/campaign',
                    },
                ],
            },
        },
        // 集章選單
        {
            path: '/reward/:id',
            name: 'Reward',
            component: Reward,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '川柳不息來集章',
                        link: '/campaign',
                    },
                    {
                        name: '川柳不息來集章',
                        link: '/reward/:id',
                    },
                ],
            },
        },
        // 證書下載
        {
            path: '/reward/:id/certificate',
            name: 'Certificate',
            component: Certificate,
            meta: {
                breadcrumb: [],
            },
        },
        // 證書下載
        {
            path: '/QRCodeUrlList',
            name: 'QRCodeUrlList',
            component: QRCodeUrlList,
            meta: {
                breadcrumb: [],
            },
        },
        // 碳跡川行
        {
            path: '/carbon',
            name: 'Carbon',
            component: Carbon,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '碳跡川行',
                        link: '/carbon',
                    },
                ],
            },
        },
        // 碳跡川行 - 固碳幫手
        {
            path: '/carbon/helper',
            name: 'Helper',
            component: Helper,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '碳跡川行',
                        link: '/carbon',
                    },
                    {
                        name: '固碳幫手',
                        link: '/carbon/helper',
                    },
                ],
            },
        },
        // 碳跡川行 - 減碳計算機
        {
            path: '/carbon/calculator',
            name: 'Calculator',
            component: Calculator,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '碳跡川行',
                        link: '/carbon',
                    },
                    {
                        name: '減碳計算機',
                        link: '/carbon/calculator',
                    },
                ],
            },
        },
        // 減碳計算機詳細頁面 - 食
        {
            path: '/carbon/calculator/food',
            name: 'CalculatorFood',
            component: CalculatorFood,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '碳跡川行',
                        link: '/carbon',
                    },
                    {
                        name: '減碳計算機',
                        link: '/carbon/calculator',
                    },
                ],
            },
        },
        // 減碳計算機詳細頁面 - 衣
        {
            path: '/carbon/calculator/cloth',
            name: 'CalculatorCloth',
            component: CalculatorCloth,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '碳跡川行',
                        link: '/carbon',
                    },
                    {
                        name: '減碳計算機',
                        link: '/carbon/calculator',
                    },
                ],
            },
        },
        // 減碳計算機詳細頁面 - 住
        {
            path: '/carbon/calculator/living',
            name: 'CalculatorLiving',
            component: CalculatorLiving,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '碳跡川行',
                        link: '/carbon',
                    },
                    {
                        name: '減碳計算機',
                        link: '/carbon/calculator',
                    },
                ],
            },
        },
        // 減碳計算機詳細頁面 - 步數計算機
        {
            path: '/carbon/calculator/steps',
            name: 'Steps',
            component: Steps,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '碳跡川行',
                        link: '/carbon',
                    },
                    {
                        name: '步數計算機',
                        link: '/carbon/calculator',
                    },
                ],
            },
        },
        // 減碳計算機詳細頁面 - 步數計算機 - 路線
        {
            path: '/carbon/calculator/stepsCalculator',
            name: 'StepsCalculator',
            component: StepsCalculator,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '碳跡川行',
                        link: '/carbon',
                    },
                    {
                        name: '步數計算機',
                        link: '/carbon/calculator',
                    },
                ],
            },
        },
        // 碳跡川行 - 負碳拚拚看
        {
            path: '/carbon/puzzle',
            name: 'Puzzle',
            component: Puzzle,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '碳跡川行',
                        link: '/carbon',
                    },
                    {
                        name: '負碳拚拚看',
                        link: '/carbon/puzzle',
                    },
                ],
            },
        },
        // 標章 - 負碳拚拚看
        {
            path: '/carbon/certificationMark',
            name: 'certificationMark',
            component: CertificationMark,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '碳跡川行',
                        link: '/carbon',
                    },
                    {
                        name: '負碳拚拚看',
                        link: '/carbon/puzzle',
                    },
                ],
            },
        },
        // 標章 - 負碳拚拚看 - 2
        {
            path: '/carbon/certificationMarkNext',
            name: 'certificationMarkNext',
            component: CertificationMarkNext,
            meta: {
                breadcrumb: [
                    {
                        name: '首頁',
                        link: '/',
                    },
                    {
                        name: '碳跡川行',
                        link: '/carbon',
                    },
                    {
                        name: '負碳拚拚看',
                        link: '/carbon/puzzle',
                    },
                ],
            },
        },

    ],
    scrollBehavior() {
        return new Promise((resolve) => {
            setTimeout(() => {
                document.querySelector('.left-side-wrapper').scrollTo(0, 0);
                resolve({
                    offset: { x: 0, y: 0 },
                });
            }, 0);
        });
    },
});
export default router;
